module.exports = __webpack_public_path__ + "img/5-1.9d0dc83f.jpg";